import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	container: {
		display: "block",
		position: "relative",
		width: 260,
		height: 180,
		cursor: "pointer",
		borderRadius: 4,
		overflow: "hidden",
		textDecoration: "none"
	},
	loadingOverlay: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%"
	},
	map: {
		// +40px wider than container: clips the OpenStreetMap zoom controls on the right edge
		width: "calc(100% + 40px)",
		// 240px vs 180px container: the extra 60px at the bottom clips the OpenStreetMap attribution text
		height: 240,
		border: "none",
		display: "block",
		pointerEvents: "none"
	}
}))

export default useStyles
